/** The app-wide stack's own words (the toasts' words come from whoever calls `notify()`). */
export const TOAST_VIEWPORT_COPY = {
  label: "Notifications",
  more: (n: number) => `+${n} more`,
  moreAria: (n: number) => `Show ${n} more ${n === 1 ? "notification" : "notifications"}`,
  fewer: "Show fewer",
  dismissAll: "Dismiss all",
  dismiss: (title: string) => `Dismiss: ${title}`,
} as const;

/** Phones show 2 at once, where the stack spans the screen; elsewhere 3 (prototype). */
export const TOAST_PHONE_QUERY = "(max-width: 35.9375rem)";
export const MAX_VISIBLE = { phone: 2, wide: 3 } as const;

/** Sticky bars at the bottom of a page (a wizard footer) mark themselves with this attribute; the stack sits above them. */
export const TOAST_AVOID_ATTRIBUTE = "data-toast-avoid";
